const ACCESS_FIXURE_TEAM_ID_QUERY = `query accessFixtureTeamId($fixtureTeamId:Int!){
  accessFixtureTeamId(fixtureTeamId:$fixtureTeamId)
}`;

module.exports = {
  ACCESS_FIXURE_TEAM_ID_QUERY,
};
